import { useQuery } from "react-query";
import { getCustomerQuality } from "api/Customers";


export const useQuality = (id?: any) => {

    const queryInfo = useQuery(
        ['customer-quality'],
        () => getCustomerQuality({ costumer_id: id }),
        {
            onError: (err) => {
                console.error(err);
            },
        }
    );

    return queryInfo;
};
